/**
 * What a transfer's MAX button resolves to.
 *
 * A transfer moves collateral off this account just as a withdrawal does — the
 * funds simply land somewhere else — so it is bounded by exactly the same two
 * things: the spendable collateral, and what margin still allows to leave.
 *
 * The shipped `computeTransferrableBalance` applied only the first of those. It
 * returned the raw spendable collateral with no margin cap at all, so a transfer
 * could move funds that were backing an open position while a withdrawal of the
 * same size was refused. Sharing `perpWithdrawMax` closes that gap, and brings
 * the USD -> token conversion of the account's `withdrawable` with it.
 */
import { MaxResult } from "./types";
import { PerpWithdrawMaxInput, perpWithdrawMax } from "./withdrawMax";

export type TransferMaxInput = PerpWithdrawMaxInput;

export const transferMax = (input: TransferMaxInput): MaxResult =>
  perpWithdrawMax(input);
